var React = require('react');

function Simplifying (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .forms {\n        fill:#e5fd57;\n        stroke:#000;\n        stroke-miterlimit:10;\n      }\n    ")),React.createElement("path",{"className":"forms","d":"M.5,371.41l130,88.57,254.54-36V75.25L256.14.52.5,31Z","key":1})]);
}

Simplifying.defaultProps = {"id":"simplifying","data-name":"simplifying","viewBox":"0 0 385.57 460.51"};

module.exports = Simplifying;

Simplifying.default = Simplifying;
